import { QuestSymbol } from 'state/vvsgotchi/models'

import MoleDashQuestDetailInfo from 'views/VvsGotchi/MoleDashGame/components/QuestDetailInfo'
import DefaultQuestDetailInfo from './Default'

import { QuestDetailInfoProps } from './types'

const QuestDetailInfo: React.FC<QuestDetailInfoProps> = (props) => {
  const { quest } = props

  switch (quest.symbol) {
    case QuestSymbol.MOLE_DASH:
      return <MoleDashQuestDetailInfo {...props} />

    default:
      return <DefaultQuestDetailInfo {...props} />
  }
}

export default QuestDetailInfo
